import { DetailEditorPropsByYear } from '../types'
import { IrrigationEditor } from './IrrigationEditor'

export const IrrigationEditorSimple = (props: DetailEditorPropsByYear) => (
  <IrrigationEditor {...props} simple />
)
